import { render, staticRenderFns } from "./products.vue?vue&type=template&id=64e5677d&scoped=true&"
import script from "./products.vue?vue&type=script&lang=js&"
export * from "./products.vue?vue&type=script&lang=js&"
import style0 from "../../css/ui-primitives.css?vue&type=style&index=0&lang=css&"
import style1 from "./products.vue?vue&type=style&index=1&id=64e5677d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e5677d",
  null
  
)

export default component.exports